import { IconButton } from '@wix/design-system';
import * as t from 'react';
import t__default, { useContext, useState } from 'react';
import { EditorContext, RicosContext } from 'ricos-context';
import { RICOS_LINE_SPACING_TYPE } from 'wix-rich-content-common';
import { FloatingLayout, FooterActions } from 'wix-rich-content-ui-components';
import { MODAL_ROOT } from '../data-hooks.js';
import { CustomSpacingEditor } from './custom-spacing-editor.js';
import { useCurrentSpacing } from './get-current-selection.js';
import { SpacingSelector } from './spacing-selector/spacing-selector.js';
import { SpacingSelectorFooter } from './spacing-selector/spacing-selector-footer.js';
import './input-with-label/input-with-label.js';
import 'lodash';
import '../defaults.js';
import '../types.js';

const r=({size:e,...o})=>t.createElement("svg",{viewBox:"0 0 24 24",fill:"currentColor",width:e||"24",height:e||"24",...o},t.createElement("path",{d:"M9.12210136,12 L16.0596461,18.9393399 C16.352647,19.2321253 16.3528218,19.706999 16.0600364,20 C15.7672509,20.293001 15.2923772,20.2931757 14.9993763,20.0003903 L7,12 L14.9993763,3.99960971 C15.2923772,3.70682428 15.7672509,3.70699902 16.0600364,4 C16.3528218,4.29300098 16.352647,4.76787468 16.0596461,5.0606601 L9.12210136,12 Z"}));r.displayName="ChevronLeftLarge";var a=r;

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Qm08G{--wds-font-size-body-medium:16px}.MSZBq{--wds-button-size-medium-screen-small:24px;--wds-color-border-dark-primary:transparent;margin-inline-end:10px}._2OZX6{--wds-font-weight-bold:400}";
var classes = {"panelRoot":"Qm08G","backButton":"MSZBq","footer":"_2OZX6"};
styleInject(css_248z);

const InsertDecorationModal = ({ closeModal }) => {
  const { getEditorCommands } = useContext(EditorContext);
  const { t, isMobile } = useContext(RicosContext);
  const editorCommands = getEditorCommands();
  const lineSpacing = useCurrentSpacing();
  const [initialLineSpacing] = useState(lineSpacing);
  const [isSpacingEditorOpen, setIsSpacingEditorOpen] = useState(false);
  const [customLineSpacing, setCustomLineSpacing] = useState(
    () => toCustomLineSpacing(initialLineSpacing)
  );
  const insertDecoration = (data, options = {}) => {
    editorCommands.insertDecoration(
      RICOS_LINE_SPACING_TYPE,
      {
        data
      },
      options
    );
    closeModal();
  };
  return /* @__PURE__ */ t__default.createElement(
    FloatingLayout,
    {
      dataHook: MODAL_ROOT,
      sidePanelProps: { width: isMobile ? "100%" : "fit-content", className: classes.panelRoot },
      onCloseButtonClick: () => {
        insertDecoration(initialLineSpacing, { shouldFocus: true });
      },
      header: isMobile ? {
        prefix: isSpacingEditorOpen ? /* @__PURE__ */ t__default.createElement(
          IconButton,
          {
            skin: "dark",
            priority: "secondary",
            className: classes.backButton,
            size: "small",
            onClick: () => setIsSpacingEditorOpen(false)
          },
          /* @__PURE__ */ t__default.createElement(a, null)
        ) : null,
        title: isSpacingEditorOpen ? t("LineSpacing_customSpacing") : t("LineSpacing_lineSpacing"),
        showDivider: true
      } : void 0,
      content: {
        noPadding: true,
        children: isSpacingEditorOpen ? /* @__PURE__ */ t__default.createElement(
          CustomSpacingEditor,
          {
            lineSpacing: customLineSpacing,
            setLineSpacing: setCustomLineSpacing
          }
        ) : /* @__PURE__ */ t__default.createElement(
          SpacingSelector,
          {
            lineSpacing,
            initialLineSpacing,
            onSelectSpacing: insertDecoration
          }
        )
      },
      footer: {
        className: classes.footer,
        children: isSpacingEditorOpen ? /* @__PURE__ */ t__default.createElement(
          FooterActions,
          {
            onCancel: closeModal,
            onSave: () => {
              insertDecoration(toLineSpacingDecoration(customLineSpacing));
            }
          }
        ) : /* @__PURE__ */ t__default.createElement(SpacingSelectorFooter, { onOpenCustomEditor: () => setIsSpacingEditorOpen(true) })
      }
    }
  );
};
const toLineSpacingDecoration = (data) => {
  return {
    "line-height": data["line-height"],
    "padding-bottom": `${data["padding-bottom"]}px`,
    "padding-top": `${data["padding-top"]}px`
  };
};
const toCustomLineSpacing = (data) => {
  var _a, _b, _c;
  return {
    "line-height": (_a = data["line-height"]) != null ? _a : "1.5",
    "padding-bottom": (_b = data["padding-bottom"].slice(0, -2)) != null ? _b : "0",
    "padding-top": (_c = data["padding-top"].slice(0, -2)) != null ? _c : "0"
  };
};

export { InsertDecorationModal };
//# sourceMappingURL=insert-decoration-modal.js.map
